export default () => {
	// Loop through 'jump-select' elements
	for (const el of document.querySelectorAll("[data-jump-select]")) {
		// When new option has been selected...
		el.addEventListener("change", (e) => {
			// If chosen option value is not empty...
			if (el.value !== "") {
				// ...redirect user to url in option value
				window.location = el.value;
			}
		});
	}
};
